import React from 'react';

import { Redirect } from 'react-router-dom'

import { FuseUtils } from '../@fuse/index'

import map from './routes/map'

const configs =
[
    map
];

const routes =
[
    ...FuseUtils.generateRoutesFromConfigs( configs ) ,
    {
        path : '/', component : () => { return <Redirect to="/"/> ; }
    }
];

export default routes ;


// WEBPACK FOOTER //
// ./src/app/routes.js